import React, { useMemo } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Box, Tooltip, ButtonGroup, Button, useTheme, useMediaQuery, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import VisxCalendarHeatmap from './VisxCalendarHeatmap';
import type { PastFloodEventFeature } from '../../layers/past_flood_events';

export type CalendarEvent = { date: Date; value: number };



export function AllSensorsCalendarModal({
  open,
  onClose,
  events,
  fromTime,
  toTime,
  timeRange,
  onSelectRange,
}: {
  open: boolean;
  onClose: () => void;
  events: PastFloodEventFeature[];
  fromTime: Date;
  toTime: Date;
  timeRange: [Date, Date];
  onSelectRange?: (range: [Date, Date]) => void;
}) {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const [mode, setMode] = React.useState<'max' | 'count' | 'sum'>('max');
  const calevents: CalendarEvent[] = useMemo(() => {
    return events?.map((e) => ({ date: e.properties.start_time, value: Number(e.properties.max_depth_inches.toFixed(2)), label: e.properties.name }));
  }, [events]);
  // console.log(fromTime, toTime, timeRange, isSmall);

  return (
    <Dialog 
        open={open} onClose={onClose} 
        maxWidth="md" fullWidth 
        sx={{ '& .MuiDialog-paper': { m: 0, maxWidth: '700px', width: '100%' } }}
        slotProps={{
          // paper: { elevation: 6 }
        }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 1, gap: 1, position: 'relative' }}>
        <Box>
          <Typography>
            Flood Event Calendar
          </Typography>
          <ButtonGroup size="small" variant="outlined" aria-label="aggregation mode" sx={{
            // '& .MuiButtonGroup-firstButton': {
            //   borderTopLeftRadius: theme.shape.borderRadius,
            //   borderBottomLeftRadius: theme.shape.borderRadius,
            // },
            // '& .MuiButtonGroup-lastButton': {
            //   borderTopRightRadius: theme.shape.borderRadius,
            //   borderBottomRightRadius: theme.shape.borderRadius,
            // },
          }}>
            <Button onClick={() => setMode('max')} variant={mode === 'max' ? 'contained' : 'outlined'}>Max Depth</Button>
            <Button onClick={() => setMode('count')} variant={mode === 'count' ? 'contained' : 'outlined'}>Number of Floods</Button>
          </ButtonGroup>
        </Box>
        <Box sx={{ flexGrow: 1 }} />
        <IconButton onClick={onClose} size="small" aria-label="close" sx={{ position: 'absolute', top: 8, right: 8 }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pb: 2, pt: 1, maxHeight: '80vh' }}>
        <Box sx={{ }}>
          {events && <VisxCalendarHeatmap
            events={calevents}
            fromTime={fromTime}
            toTime={toTime}
            selectionFrom={timeRange[0]}
            selectionTo={timeRange[1]}
            onSelectRange={onSelectRange}
            cell={isSmall ? 9 : 18}
            gap={isSmall ? 0.2 : 0.8}
            valueMode={mode}
            units={' in'}
          >
            {/* {({ year, events, eventsByDay, valueMode }) => {
              console.log(year, events);
              const top = events.flatMap(({ bin: m, bins }) => bins.map(({ bin: d, count }) => ({ date: new Date(year, m, d+1), value: count, label: '' }))).sort((a,b) => b.value - a.value).slice(0, 5);
              return (
                <ul style={{ margin: 0, paddingLeft: 16 }}>
                  {top.map((e, i) => (
                    <li key={i}>
                    {e.date.toLocaleDateString()} — {eventsByDay.get(+e.date)?.length || 0} events - {valueMode === 'max' ? Math.max(...(eventsByDay.get(+e.date)?.map(ev => ev.value) || [0])) : e.value}{' '}
                    </li>
                  ))}
                </ul>
              );
            }} */}
          </VisxCalendarHeatmap>
          }
        </Box>
      </DialogContent>
    </Dialog>
  );
}


function AllSensorsCalendarModalAndButton(props: {
  events: PastFloodEventFeature[];
  fromTime: Date;
  toTime: Date;
  timeRange: [Date, Date];
  onSelectRange?: (range: [Date, Date]) => void;
}) {
  const [open, setOpen] = React.useState(false);
  const doOpen = React.useCallback(() => setOpen(true), []);
  const doClose = React.useCallback(() => setOpen(false), []);
  return (
    <>
      <Tooltip title="Calendar heatmap">
        <IconButton color="default" onClick={doOpen}>
          <CalendarMonthIcon />
        </IconButton>
      </Tooltip>
      <AllSensorsCalendarModal open={open} onClose={doClose} {...props} />
    </>
  );
} 

export default React.memo(AllSensorsCalendarModal);